var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-radio-group",
        {
          attrs: { name: "items-" + _vm.group.id, stacked: "" },
          on: { change: _vm.onSelectItem },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [
          _c("b-form-radio", { attrs: { value: null } }, [
            _vm._v("Keine Einschränkung")
          ]),
          _vm._v(" "),
          _vm._l(_vm.group.items, function(item) {
            return _c(
              "b-form-radio",
              {
                key: item.fuzzyType,
                staticClass: "mt-4",
                attrs: { value: item }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.getFuzzyTypeLabel(item)) +
                      " (" +
                      _vm._s(item.count) +
                      ")"
                  )
                ]),
                _vm._v(" "),
                item.info
                  ? _c("span", { staticClass: "d-block mt-1" }, [
                      _vm._v("\n\t\t\t\t" + _vm._s(item.info) + "\n\t\t\t")
                    ])
                  : _vm._e()
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }